import { useState } from 'react';
import { BenefitsDeductionsPanel } from '../../../compensation/components/BenefitsDeductionsPanel';
import { EmployeeBenefitsDeductions } from '../../components/EmployeeBenefitsDeductions';
import { EmployeeLeavePlans } from '../../components/EmployeeLeavePlans';
import type { EmployeeProfileStepProps } from './EmployeeSetupStep';

type SettingsTab = 'benefits-deductions' | 'leave-plans';

// Additional Settings — two REAL sections, both employee-scoped with no internal employee picker:
// Benefits/Deductions (EmployeeBenefitsDeductions: one table over the employee's benefit and deduction assignments, added from the unified company catalog) and
// Employee Leave Plans (EmployeeLeavePlans, the Figma admin S01 to S16 table over the employee's leave plan setups; docs/leave-plan-setup-contract.md).
// The collapsed "Benefit plan elections" section under the table (BenefitsDeductionsPanel, benefits only) is kept unchanged for what the table does not do yet:
// waivers, qualifying-event reasons and the per-election history.
export function AdditionalSettingsStep({ employee }: EmployeeProfileStepProps) {
  const [tab, setTab] = useState<SettingsTab>('benefits-deductions');

  return (
    <div className="additional-settings-step">
      <div className="tabs">
        <button type="button" className={tab === 'benefits-deductions' ? 'tab tab--active' : 'tab'} onClick={() => setTab('benefits-deductions')}>
          Benefits / Deductions
        </button>
        <button type="button" className={tab === 'leave-plans' ? 'tab tab--active' : 'tab'} onClick={() => setTab('leave-plans')}>
          Employee Leave Plans
        </button>
      </div>

      {tab === 'benefits-deductions' && (
        <section className="profile-section">
          <h3 className="profile-section-title">Benefits / Deductions</h3>
          <EmployeeBenefitsDeductions employeeId={employee.id} />
          <details className="bd-plans">
            <summary>Benefit plan elections</summary>
            <BenefitsDeductionsPanel employeeId={employee.id} benefitsOnly />
          </details>
        </section>
      )}

      {tab === 'leave-plans' && (
        <section className="profile-section">
          <h3 className="profile-section-title">Employee Leave Plans</h3>
          <EmployeeLeavePlans employeeId={employee.id} />
        </section>
      )}
    </div>
  );
}
